/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Matchingdaydate_No_Date2Inputs */

const en_job_form_matchingdaydate_no_date2 = /** @type {(inputs: Job_Form_Matchingdaydate_No_Date2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No date has been set for this Matching Day yet`)
};

const de_job_form_matchingdaydate_no_date2 = /** @type {(inputs: Job_Form_Matchingdaydate_No_Date2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für diesen Matching Day ist noch kein Datum festgelegt`)
};

/**
* | output |
* | --- |
* | "No date has been set for this Matching Day yet" |
*
* @param {Job_Form_Matchingdaydate_No_Date2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_matchingdaydate_no_date2 = /** @type {((inputs?: Job_Form_Matchingdaydate_No_Date2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Matchingdaydate_No_Date2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_matchingdaydate_no_date2(inputs)
	return en_job_form_matchingdaydate_no_date2(inputs)
});
export { job_form_matchingdaydate_no_date2 as "job_form_matchingDayDate_no_date" }